import { useEffect, useState } from 'react';
import Dialogo from '@/components/Dialogo';

/**
 * Encerrar: enviar a despedida ou não.
 *
 * Antes o texto configurado saía sempre. Mas há conversa que não pede despedida
 * — o paciente já se despediu, ou o encerramento acontece dias depois, ou foi
 * engano. Mandar "obrigado pelo contato" ali reabre a conversa do lado do
 * paciente, que responde e ela volta para a fila.
 *
 * O diálogo mostra o texto REAL antes de decidir. As variáveis
 * (`{{primeiro_nome}}` e afins) só são resolvidas no servidor, então a prévia é
 * o modelo — e é assim que ela se anuncia, para ninguém achar que o paciente
 * receberá as chaves.
 */
export default function DialogoEncerrar({ aberto, texto, aoFechar, aoDecidir }) {
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (aberto) {
      setEnviando(false);
      setErro(null);
    }
  }, [aberto]);

  async function decidir(enviar) {
    setEnviando(true);
    setErro(null);
    try {
      await aoDecidir(enviar);
    } catch (e) {
      console.error('[OdontoSDR] Falha ao encerrar:', e);
      setErro(e?.message ?? 'Não foi possível encerrar a conversa.');
      setEnviando(false);
    }
  }

  return (
    <Dialogo titulo="Encerrar conversa" aberto={aberto} aoFechar={aoFechar} largura={480}>
      <div className="dialogo-corpo">
        <p>Quer enviar a mensagem de encerramento ao paciente?</p>

        <p className="previa-balao">{texto}</p>
        <p className="campo-ajuda">
          As variáveis são preenchidas no envio — o paciente não vê as chaves.
        </p>

        {erro && <p className="erro">{erro}</p>}

        <footer className="dialogo-acoes">
          <button type="button" className="btn-texto" onClick={aoFechar} disabled={enviando}>
            Cancelar
          </button>
          {/* "Só encerrar" primeiro: é a ação sem efeito externo, e a que não
              tem como dar errado com o paciente. */}
          <button
            type="button"
            className="btn-secundario"
            onClick={() => decidir(false)}
            disabled={enviando}
          >
            Não, só encerrar
          </button>
          <button
            type="button"
            className="btn-primario"
            onClick={() => decidir(true)}
            disabled={enviando}
          >
            {enviando ? 'Encerrando…' : 'Sim, enviar e encerrar'}
          </button>
        </footer>
      </div>
    </Dialogo>
  );
}
